import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardCodeEditTemplate } from 'components/Templates'

const PointCardCodeEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/code\/[^/]+\/edit/.test(pathname)
  const pointCardCodeId = isEdit ? pathname.split(/^\/point_card\/code\/([^/]+)\/edit/)[1] : undefined

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'QRコード'} title={'QRコード'}>
      <PointCardCodeEditTemplate isEdit={isEdit} pointCardCodeId={pointCardCodeId} />
    </Layout>
  )
}

export default PointCardCodeEdit
